import { ArcSeg2d } from '../math/arcSeg2d';
import { Circle2d } from '../math/circle2d';
import { IPoint2d } from '../math/IPoint2d';
import { Line2d } from '../math/Line2d';
import { LineSeg2d } from '../math/LineSeg2d';
import { Ray2d } from '../math/ray2d';

export enum ERelationOfPointOnSeg {
  NoRelation = 'NoRelation',
  Start = 'Start',
  End = 'End',
  Between = 'Between'
}

// 线段之间的关系
export enum ERelationToSeg {
  NoRelation = 'NoRelation',
  Same = 'Same',
  Opposite = 'Opposite',

  // 端点-端点重叠
  MainStartStartOverlap = 'MainStartStartOverlap',
  MainStartEndOverlap = 'MainStartEndOverlap',
  MainEndStartOverlap = 'MainEndStartOverlap',
  MainEndEndOverlap = 'MainEndEndOverlap',

  // 端点-线段
  MainStartOnSegInternal = 'MainStartOnSegInternal', // 主线起点在副线上（排除副线端点）
  MainEndOnSegInternal = 'MainEndOnSegInternal', // 主线终点在副线上（排除副线端点）

  MainSegContainStartInternal = 'MainSegContainStartInternal', // 主线包含副线起点(排除主线端点)
  MainSegContainEndInternal = 'MainSegContainEndInternal', // 主线包含副线终点(排除主线端点)

  Overlap = 'Overlap', // 部份重叠

  IntersectInternal = 'IntersectInternal', // 相交（两线段内部有交点）

  /** 相切 */
  Tangency = 'Tangency'
}

export type IShape2d = Line2d | LineSeg2d | ArcSeg2d | Circle2d | Ray2d;
export type IShapeSeg2d = LineSeg2d | ArcSeg2d;

// 扩展IPoint2d，结合下一个点，可得到圆弧数据
export type IShapePoint2d = IPoint2d & { center?: IPoint2d; clockwise?: boolean };

// 两个闭合区域之间的关系
export enum EClosedPathRelation {
  NoRelation = 'NoRelation', // 没有包含关系，也不相交
  Overlap = 'Overlap', // 完全重叠(不包含部份重叠)
  Intersect = 'Intersect', // 相交
  Inside = 'Inside', // shapeA在shapeB内部
  Outside = 'Outside' // shapeA在shapeB外部
}

// 点与闭合区域之间的关系
export enum EPointAndClosedRelation {
  On = 'On', // 点在闭合区域边界上
  Inside = 'Inside', // 点在闭合区域内部
  Outside = 'Outside' // 点在闭合区域外部
}
